import { useParams } from 'react-router-dom'
import { useAccountSpaces } from '@/hooks/useAccountSpaces.jsx'

// Get the relevant space based on the URL ':spaceId'. Resolution is scoped to
// the account in the URL (':accountId') - a spaceId that belongs to a different
// account resolves to undefined, so SpaceGuard rejects it and SpaceDefault
// redirects the user to a space that actually belongs to their chosen account.
export const useCurrentSpace = () => {
    const { spaceId } = useParams()
    const { accountSpaces } = useAccountSpaces()

    const currentSpace = accountSpaces.find(space => space._id === spaceId)

    return { space: currentSpace, isDemoSpace: currentSpace?.isDemo || false }
}